import { createFileRoute, Outlet } from '@tanstack/react-router'
import { SystemLens } from 'pages/systemLens/SystemLens'

export const Route = createFileRoute('/system-lens/{-$siteID}')({
  component: SystemLensPage,
  staticData: {
    title: 'System Lens',
  },
})

function SystemLensPage() {
  const { siteID } = Route.useParams()
  if (!siteID) {
    return <Outlet />
  }

  return <SystemLens siteId={siteID} />
}
